import React from 'react';
import styled from 'styled-components';
import {device} from '../../assets/device'
import {parseDatetimeString} from '../../services/dates';

export const EventSportDateInfoStyles = {
	DateInfo: styled.div`
      display: flex;
      //noinspection ALL
      @media ${device.tablet} {
        display: inline-block;
        padding: .5rem 0 0;
        flex-wrap: wrap;
      }
	  
      .date-info__date {
        width: 100%;
        margin-right: 1em;
        color: #6E6E6E;
        font-size: 1.3em;
        font-weight: 600;
        line-height: .9em;
        display: flex;
        align-items: center;
        //noinspection ALL
        @media ${device.tablet} {
          margin: 0;
          justify-content: flex-start;
          font-size: 1.5em;
          font-weight: 700;
          color: #b2aeae;
        }
      }

      .date-info__date-time {
        align-items: center;
        align-self: flex-start;
        width: 115%;
        font-size: 1.3em;
        font-weight: 600;
        color: #6E6E6E;
        //noinspection ALL
        @media ${device.tablet} {
          font-weight: 400;
          color: #b3b3b3;
          text-align: center;
          width: 100%;
          padding: 0.5rem 0 0.5rem 0;
          font-size: 1.1em;
        }
      }
	`,
};

const S = EventSportDateInfoStyles;

const EventSportDateInfo = ({event}) => {
	const beginDate = parseDatetimeString(event.begin).format('DD.MM.YYYY');
	const beginTimeStr = parseDatetimeString(event.begin).format('HH:mm');

	return (
		<S.DateInfo>
			<div className="date-info__date">
				{beginDate}
			</div>
			<div className="date-info__date-time">
				{beginTimeStr} Uhr
			</div>
		</S.DateInfo>
	);
};

export default EventSportDateInfo;
